export const GET_BRAND_CHILD_CLIENT_COUNTRIES = 'GET_BRAND_CHILD_CLIENT_COUNTRIES';
export const GET_BRAND_CHILD_CLIENT_COUNTRIES_SUCCESS = 'GET_BRAND_CHILD_CLIENT_COUNTRIES_SUCCESS';
export const GET_BRAND_CHILD_CLIENT_COUNTRIES_ERROR = 'GET_BRAND_CHILD_CLIENT_COUNTRIES_ERROR';
export const GET_BRAND_CHILD_CLIENT_COUNTRIES_NONE = 'GET_BRAND_CHILD_CLIENT_COUNTRIES_NONE';
export const GET_BRAND_CHILD_CLIENT_COUNTRIES_INPROGRESS = 'GET_BRAND_CHILD_CLIENT_COUNTRIES_INPROGRESS';